import React from 'react';

// Components
import ChangeLogEntries from './ChangeLogEntries';

const ChangeLog = ({ entries }) => (
  <div className="admin-profile-card-list-container">
    <h3>Change Log</h3>
    <ChangeLogEntries entries={entries} />
  </div>
)

export default ChangeLog



// WEBPACK FOOTER //
// ./src/components/Admin/Profile/ChangeLog.js